export function findStep(workflow, id) {
  return workflow.steps.find((step) => step.id === id);
}

export function findTrigger(workflow, id) {
  return workflow.triggers.find((trigger) => trigger.id === id);
}

export function attach(workflow, sourceId, targetId) {
  const trigger = findTrigger(workflow, sourceId);

  return trigger ? start(workflow, trigger, targetId) : link(workflow, sourceId, targetId);
}

export function unattach(workflow, sourceId, targetId) {
  const trigger = findTrigger(workflow, sourceId);

  if (trigger) {
    trigger.starts = trigger.starts.filter((id) => id !== targetId);

    return;
  }

  const target = findStep(workflow, targetId);

  if (target) target.dependsOn = target.dependsOn.filter((id) => id !== sourceId);
}

export function removeStep(workflow, id) {
  workflow.steps = workflow.steps.filter((step) => step.id !== id);
  workflow.steps.forEach((step) => {
    step.dependsOn = step.dependsOn.filter((parentId) => parentId !== id);
  });
  workflow.triggers.forEach((trigger) => {
    trigger.starts = trigger.starts.filter((stepId) => stepId !== id);
  });
}

export function removeTrigger(workflow, id) {
  workflow.triggers = workflow.triggers.filter((trigger) => trigger.id !== id);
}

export function hydrate(workflow) {
  workflow.concurrency = {
    mode: workflow.concurrency?.mode ?? 'off',
    key: workflow.concurrency?.key ?? '',
  };

  const idForKey = new Map(workflow.steps.map((step) => [step.key, step.id]));

  for (const step of workflow.steps) {
    step.dependsOn = (step.dependsOnKeys ?? [])
      .map((key) => idForKey.get(key))
      .filter((id) => id && id !== step.id);
    delete step.dependsOnKeys;
  }

  for (const trigger of workflow.triggers) {
    trigger.starts = (trigger.stepKeys ?? []).map((key) => idForKey.get(key)).filter(Boolean);
    delete trigger.stepKeys;
  }

  return workflow;
}

function start(workflow, trigger, stepId) {
  if (!findStep(workflow, stepId) || trigger.starts.includes(stepId)) return false;

  trigger.starts.push(stepId);

  return true;
}

function link(workflow, sourceId, targetId) {
  const target = findStep(workflow, targetId);

  if (!target || sourceId === targetId || target.dependsOn.includes(sourceId)) return false;
  if (wouldCycle(workflow, sourceId, targetId)) return false;

  target.dependsOn.push(sourceId);

  return true;
}

function wouldCycle(workflow, sourceId, targetId) {
  const stack = [sourceId];
  const seen = new Set();

  while (stack.length > 0) {
    const id = stack.pop();

    if (id === targetId) return true;
    if (seen.has(id)) continue;

    seen.add(id);
    stack.push(...(findStep(workflow, id)?.dependsOn ?? []));
  }

  return false;
}
